import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { QuoteProvider } from "../../context/QuoteContext";
import { trackVisit } from "../../lib/api";
import { TopAlert } from "./TopAlert";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingActions } from "./FloatingActions";
import Home from "../../pages/Home";
import Products from "../../pages/Products";
import Vehicles from "../../pages/Vehicles";
import InfoPage from "../../pages/InfoPage";
import Contact from "../../pages/Contact";

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); trackVisit(pathname); }, [pathname]);
  return null;
}

export default function SiteLayout() {
  return (
    <QuoteProvider>
      <PageTracker />
      <TopAlert />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/tenders" element={<InfoPage type="tenders" />} />
          <Route path="/services" element={<InfoPage type="services" />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <FloatingActions />
    </QuoteProvider>
  );
}
